module.exports = __webpack_public_path__ + "static/media/dress-shoes.c8def149.jpg";